<section class="wf100 subheader1"
    style="background-image: url('assets/images/Aboutus_img/backg.png'); background-size: cover; background-position: center; background-repeat: no-repeat; padding: 100px 0;">
    <div class="container">
        <h2 style="margin-left: -100px; color: #ffffff; font-size: 30px;">sitemap</h2>
        <ul class="breadcrumb">
            <li>
                <a routerLink="/" style="color: rgb(255, 255, 255);margin-left: -100px; font-size: 15px;">Home
                    &nbsp;/
                </a>
            </li>
            <li>
                <a routerLink="/our-initiation" style="color: rgb(255, 255, 255) ;font-size: 15px;">sitemap </a>
            </li>
        </ul>
    </div>
</section><br>


<div class="container mt-3 ">
    <div class="shadow p-3 mb-5 bg-body rounded">
        <h5>
            <ul>
                <li>मुखपृष्ठ</li><br>
                <li>आमच्याबद्दल</li><br>
               
                <li>योजनांचा तपशील
                    <ul><br>
                        <li>देशी गाईच्या परिपोषणासाठी प्रति दिन अनुदान योजना</li><br>
                        
                    </ul><br>
                </li>
                <li>अर्ज करा</li><br>
                <li>वेळापत्रक </li><br>
                <li>संपर्क</li><br>
                <li>अधिकारी लॉगिन</li><br>
                <li>सामान्य प्रश्न</li><br>
                <li>माहिती</li><br>
                <li>युट्युब व्हिडिओस </li><br>
                <li>privacy policy</li><br>
                <li>sitemap</li><br>
            </ul>
        </h5>
    </div>
</div>
